var render = function render(){var _vm=this,_c=_vm._self._c;return _c('events-section',{attrs:{"events":_vm.events},on:{"setEventsPage":_vm.getEvents}})
}
var staticRenderFns = []

export { render, staticRenderFns }